import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const About = lazy(() => import("../pages/about/page"));
const Services = lazy(() => import("../pages/services/page"));
const Testimonials = lazy(() => import("../pages/testimonials/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const ArticleDetail = lazy(() => import("../pages/blog/detail/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const FAQ = lazy(() => import("../pages/faq/page"));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <ArticleDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/faq", element: <FAQ /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
